// Setup for vue router for MetadataList component
import MetadataList from "@/browse/MetadataList.vue";
import VueRouter from "vue-router";
import Vue from "vue";


const routes = [
  { path: '/', component: MetadataList }
]

const router = new VueRouter({
    mode: 'history',
    routes: routes
  });

Vue.use(VueRouter)

export default router
